import { fetchAuthSession } from "aws-amplify/auth";
import { isAccessTokenExpired } from "~/shared/api/core/api";
import { queryClient } from "~/shared/api/core/query-client";
import { USERS_KEYS } from "~/shared/api/users/users.queries";

export async function authenticationTokenRefresh() {
  try {
    const { tokens } = await fetchAuthSession();

    if (tokens?.accessToken == null) {
      throw new Error("No access token available");
    }

    if (isAccessTokenExpired(tokens.accessToken.payload.exp)) {
      const { tokens } = await fetchAuthSession({ forceRefresh: true });
      queryClient.invalidateQueries({ queryKey: USERS_KEYS.all });

      if (tokens?.accessToken == null) {
        throw new Error("Failed to refresh access token");
      }

      // Return the new token
      return tokens.accessToken.toString();
    }

    // Return the existing token
    return tokens.accessToken.toString();
  } catch (_err) {
    // If the user is not authenticated, return null
    return null;
  }
}
